import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MessageService, SelectItem } from 'primeng/api';
import {
  batStaMapping, groupStr, outStaMapping, powSourMapping, timeZoneOption,
  unitMapping, unitOption, updateInfoType, PackageList
} from '../../shareModel';
import { environment } from '../../../environments/environment';
import { select, Store } from '@ngrx/store';
import * as fromStore from '../../store';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject, combineLatest } from 'rxjs';
import { takeUntil, first } from 'rxjs/operators';
import { Group } from '../../models/group';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EventsParams, FilterParams } from '../../models/events';
import { isODM } from '../../../environments/environment';
import { Confirm_button } from '../../../environments/environment';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { PreferenceService } from '../../services/preference.service';
import { DialogComponent } from '../../../app/dialog/dialog.component';
import {CryptoService} from '../../services/crypto.service';
import { Router } from '@angular/router';
import { User } from '../../models/user';

@Component({
  standalone: false,
  selector: 'app-group-detail',
  templateUrl: './group-detail.component.html',
  styleUrls: ['./group-detail.component.css']
})
export class GroupDetailComponent implements OnInit, OnDestroy {
  eventLogs_cols: any[] = [
    { field: 'status', header: TRANSLATE('Status'), width: '100', class: 'col-nowrap text-center', disabled: false },
    { field: 'time', header: TRANSLATE('Time'), width: '180', class: 'col-nowrap', disabled: false },
    { field: 'timezoneLabel', header: TRANSLATE('Time Zone'), width: '120', class: 'hidden-sm', disabled: false },
    { field: 'name', header: TRANSLATE('Device Name'), width: '200', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'desc', header: TRANSLATE('Description'), width: '100%', class: 'desc', disabled: false },
  ];
  powerMaster = isODM;
  Confirm_button = Confirm_button;
  timezoneOptions: SelectItem[] = timeZoneOption;
  unitOptions: SelectItem[] = unitOption;
  display = false;
  isMsp = false;
  indexNum = 0;
  energyRangeStart: Date;
  energyRangeEnd: Date;
  gId: string;
  groupParam = {} as Group;
  public componentDestroyed = new Subject();
  energyInfoFeature: Boolean;
  eventLogs$: Observable<any>;
  curDate = new Date();
  companionAlert = true;
  RangeParam: EventsParams = {
    otp: '',
    startDate: new Date(this.curDate.getTime() - 24 * 60 * 60 * 1000 * 3),
    endDate: new Date()
  };
  eventParams: FilterParams = {
    deviceName: '',
    status: -1,
    sn: '',
    type: groupStr
  };
  localTimeZone = new Date().getTimezoneOffset() / 60;
  cols: any[] = [
    { field: 'status', header: TRANSLATE('Status'), width: '80', class: 'col-nowrap text-center', disabled: false },
    { field: 'setting', header: '', width: '80', class: 'col-nowrap text-center groupSetting', disabled: true },
    { field: 'name', header: TRANSLATE('Name'), width: '250', class: '', disabled: false },
    { field: 'type', header: TRANSLATE('Type'), width: '120', class: 'hidden-sm', disabled: false },
    { field: 'desc', header: TRANSLATE('Description'), width: '', class: 'desc', disabled: false }
  ];
  groupOriginalSetting = {
    region: 0,
    deviceDescription: ''
  };
  NotMspDeviceInfoIsRead = false;
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  constructor(
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private store: Store<fromStore.State>,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService,
    private preferenceService: PreferenceService,
    private location: Location,
    private cryptoService: CryptoService,
    private router: Router) {
    this.store.select(fromStore.getGroupDetails).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      const allDevices = [];
      if (res.is_shared && res.shared_devices && res.shared_devices.length > 0) {
        allDevices.push(...res.shared_devices);
      } else if (res.devices && res.devices.length > 0) {
        allDevices.push(...res.devices);
      }
      this.groupParam = { ...res, All_devices: allDevices };
      this.groupOriginalSetting.region = res.TimeZone;
      this.groupOriginalSetting.deviceDescription = res.Description;
    });
    this.eventLogs$ = this.store.pipe(select(fromStore.getEventLogData));

    this.store.select(fromStore.getIsActiveUserModule, PackageList.Companion).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      // const packageCompanion = Boolean(res);
      const packageCompanion = false;
      if (!packageCompanion) {
        this.companionAlert = false;
      }
    });

    // Get isMsp
    this.store.select(fromStore.getIsMsp).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined && res !== null) {
        this.isMsp = res;
      }
    });

    // combineLatest(this.store.select(fromStore.getCurrentUser), this.store.select(fromStore.getMspRegionFilter))
    // .pipe(takeUntil(this.componentDestroyed)).subscribe(([user, filter]) => {
    //   this.RangeParam.RegionIds = null;
    //   if (user && !user.isLoading && user.isLoaded && user.isLogin && filter !== null && filter.filterLoaded) {
    //     if (filter.isMsp) {
    //       this.RangeParam.RegionIds = filter.selectedId;
    //     }
    //     // this.store.dispatch(new fromStore.GetEventFilterParams(this.eventParams));
    //     this.store.dispatch(new fromStore.GetEventAction(this.RangeParam));
    //   }
    // });
    this.store.select(fromStore.getMspRegionFilter).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.patchRangeParam({ RegionIds: null });
      if (res !== null) {
        if (res.isMsp && res.filterLoaded) {
          this.patchRangeParam({ RegionIds: res.selectedId });
          this.store.dispatch(new fromStore.GetEventAction({ ...this.RangeParam }));
        } else if (!res.isMsp && !this.NotMspDeviceInfoIsRead) {
          this.store.dispatch(new fromStore.GetEventAction({ ...this.RangeParam }));
          this.NotMspDeviceInfoIsRead = true;
        }
      }
    });
  }
  ngOnInit() {
    this.ngxService.start();
    this.packageSetting();
    this.UI();
    this.gId = this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('gId'));
    this.eventParams = {
      ...this.eventParams,
      filterId: 'group-' + this.gId,
    };
    this.store.dispatch(new fromStore.GetGroupDetails(Number(this.gId)));
    // this.store.dispatch(new fromStore.GetEventAction(this.RangeParam));
    this.store.dispatch(new fromStore.GetEventFilterParams({ ...this.eventParams }));
    this.ngxService.stop();
  }

  profileSave() {
    const params = {
      Id: this.groupParam.Id,
      TimeZone: this.groupParam.TimeZone,
      Description: this.groupParam.Description,
    } as Group;
    this.store.dispatch(new fromStore.UpdateGroupDetails(params));
    this.store.select(fromStore.getUpdateInfoState)
      .pipe(first(res => res.isLoaded && res.type === updateInfoType.EditGroup))
      .subscribe(res => {
        if (res.type === updateInfoType.EditGroup) {
          if (res.isLoading) {
            console.log('...Loading');
          } else {
            if (res.isLoaded) {
              if (res.isSaved) {
                this.messageService.add({ severity: 'success', summary: this.translateService.instant('Update Success') });
                this.refresh(params.Id);
              } else {
                this.messageService.add({ severity: 'error', summary: this.translateService.instant('Update Fail') });
              }
            }
          }
        }
      });
  }

  refresh(gId) {
    const UserParam = {regionIds: this.RangeParam.RegionIds} as User;
    this.store.dispatch(new fromStore.GetDevicesStatusAction(UserParam));
    this.store.dispatch(new fromStore.GetGroupDetails(gId));
    this.display = false;
  }

  resetField() {
    this.groupParam = {
      ...this.groupParam,
      TimeZone: this.groupOriginalSetting.region,
      Description: this.groupOriginalSetting.deviceDescription,
    };
  }

  packageSetting() {
    this.store.select(fromStore.getIsActiveUserModule, PackageList.EnergyInfo).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.energyInfoFeature = Boolean(res);
    });
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  private patchRangeParam(patch: Partial<EventsParams>): void {
    this.RangeParam = { ...this.RangeParam, ...patch };
  }

  onTabChange(e) {
    this.indexNum = e.index;
  }

  goBack(): void {
    this.location.back();
  }

  displayExpiredDialog(item) {
    if (!this.isMsp) {
      this.childDialog.expiredDialog(item);
    }
  }

  displayisTrialDialog(item) {
    this.childDialog.isTrialDialog(item);
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-landing');
    body.classList.remove('body-login');
    body.classList.remove('layout-toggle');
    body.classList.remove('mobile-toggle');
    body.classList.remove('events');
  }

  routerCompanion() {
    this.router.navigate(['/companion']);
  }
}
